import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useStyles } from './ecp-locator.styles';
import { InternalLinks } from '../../../../../constants';
import { ContentWrapper } from '../../../../common/content-wrapper';
import mapMobile from '../../../../../assets/images/backgrounds/ecp-locator/map-with-markers-mobile.jpg';
import map from '../../../../../assets/images/backgrounds/ecp-locator/map-with-markers.jpg';

export const EcpLocator = (): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <section
      data-testid="ecp-locator-landing-wrapper" // Don't remove data-testid, it is used by Yandex Metrica
      aria-label={intl.formatMessage({ id: 'ecp.landing.section.ariaLabel' })}
      className={classes.container}
    >
      <ContentWrapper>
        <div className={classes.root}>
          <div>
            <h2
              data-testid="ecp-locator-landing-title"
              className={classes.sectionTitle}
            >
              <FormattedMessage id="ecpPreview.title" />
            </h2>
            <p
              data-testid="ecp-locator-landing-description"
              className={classes.description}
            >
              {intl.formatMessage(
                { id: 'ecpPreview.description' },
                { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
              )}
            </p>
            {!isTablet && (
              <img src={mapMobile} alt="" className={classes.img} data-testid="ecp-preview-img" />
            )}
            <a
              data-testid="ecp-locator-landing-button"
              href={InternalLinks.ecpLocator}
              className={classes.button}
            >
              <span>
                <FormattedMessage id="ecpPreview.searchCard.searchButton.label" />
              </span>
            </a>
          </div>
          {isTablet && (
            <img src={map} alt="" className={classes.img} data-testid="ecp-preview-img" />
          )}
        </div>
      </ContentWrapper>
    </section>
  );
};
